<template>
    <v-flex>
        <v-toolbar
                dark
                fixed
                flat
                :class="$route.meta.colorToolbar === 'gradient' ? 'gradient' : ''"
                :app="$route.meta.colorToolbar === 'black'"
                clipped-right
                scroll-off-screen
        >
            <img
                    :src="require('@/assets/img/innovation/nttdata_bianco.png')"
                    :width="tabletAndDown() ? 50 : 150"
                    @click="navigate( '/oic11/results' )"
                    height="auto"
            />
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn :large="!tabletAndDown()" :small="tabletAndDown()" :icon="tabletAndDown()" flat dark @click="logout"><v-flex v-if="!tabletAndDown()">Logout</v-flex><v-icon medium dark>mdi-account</v-icon></v-btn>
            </v-toolbar-items>
        </v-toolbar>

    </v-flex>
</template>

<script>
    import RouterService from "@/helpers/RouterService";
    import {validationMixin,} from "vuelidate";
    import {maxLength, minLength, required,} from "vuelidate/lib/validators";
    import UrlsService from "@/helpers/UrlsService";
    import TimeService from "@/helpers/TimeService";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import NotificationService from "@/helpers/NotificationService";
    import {mapGetters,mapState} from "vuex";


    export default {
        name: "AppToolbarGhostLogout",
        components: {},
        data() {
            return {
            };
        },
        methods: {
            logout(){
                RouterService.goTo({name: "LoginGhost", params: {isLogout: true}});

            },
            tabletAndDown() {
                return this.$vuetify.breakpoint.name === "xs" ||
                    this.$vuetify.breakpoint.name === "sm";
            },
            navigate(path) {
                RouterService.goTo(path);
            },
        },
    };
</script>

<style lang="scss" scoped>

    .transparent{
        background-color: transparent !important;
    }

    .gradient {
        background: linear-gradient(to top, rgba(0,0,0,0), rgba(0,0,0,0.6));
    }

    .tile {
        background: transparent;
        margin: 5px;
        border-radius: 4px;
    }
    .tile:hover {
        background: black;
    }

</style>
